export const emotionList = [
  {
    emotion_id: 1,
    emotion_img: `/assets/emotion1.png`,
    emotion_description: "超ハッピー",
  },
  {
    emotion_id: 2,
    emotion_img: `/assets/emotion2.png`,
    emotion_description: "ハッピー",
  },
  {
    emotion_id: 3,
    emotion_img: `/assets/emotion3.png`,
    emotion_description: "まあまあ",
  },
  {
    emotion_id: 4,
    emotion_img: `/assets/emotion4.png`,
    emotion_description: "悪い",
  },
  {
    emotion_id: 5,
    emotion_img: `/assets/emotion5.png`,
    emotion_description: "最低",
  },
];
